<template>
  <div>
    <div v-if="loading || user === undefined" class="spinner text-xs-center mt-4 mb-4">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
    <div v-else-if="user">
      <div style="position: absolute; right: 10px; z-index: 4;" class="mr-2">
        <v-btn outline small @click="fetchDataUser" color="white" style="min-width: 50px;">
          <i class="fa fa-refresh" style="font-size: 17px;" aria-hidden="true"></i
        ></v-btn>
      </div>
      <customer-detail
        :pageid="pageid"
        :is_leave_group="value.is_leave_group"
        :is_blocked="value.is_blocked"
        :group_id="value.group_id"
        v-model="user"
        :getuseronly="true"
        :loaduser="false"
      >
        <div slot="header">&nbsp;</div>
      </customer-detail>
      <template v-if="$aston.astonpages.includes($store.state.livechat.pageid)">
        <v-divider />
        <div class="px-2">
          <div class=" mt-4">Assign to</div>
          <v-select
            v-model="assignadminname"
            :items="computedAstonAdmins"
            outline
            label="Assign to"
            hide-details
            class="mt-1"
            color="primary"
            @change="changeAsssign"
          ></v-select>

          <div class=" mt-4">ประเภทลูกค้า</div>
          <v-select
            v-model="session"
            :items="$store.state.astonCustomerGroup"
            outline
            label="ประเภทลูกค้า"
            hide-details
            class="mt-1"
            color="primary"
            @change="changeSession"
          ></v-select>
          <div class="mb-4"></div>
        </div>
      </template>
    </div>
    <div v-else>
      <div class="text-xs-center mt-4 mb-4">
        <v-icon x-large>error_outline</v-icon>
        <p>No detail</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import CustomerDetail from '@/components/view/analytics/CustomerDetail.vue'
import EventBus from '@/utils/event-bus'

export default {
  props: ['value', 'pageid'],
  components: {
    CustomerDetail
  },
  data: function() {
    return {
      loading: true,
      chatboxHeight: 0,
      session: '',
      assignadminname: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      user: 'getLivechatUser'
    }),
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map(el => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  async mounted() {
    this.fetchDataUser()

    EventBus.$on('update:tags', () => {
      this.fetchDataUser()
    })
  
    this.$on('hook:beforeDestroy', () => {
      EventBus.$off('update:tags')
    })
  },
  methods: {
    async fetchDataUser() {
      const vm = this
      vm.loading = true
      vm.$store.state.livechat.loadingUser = true

      try {
        let user = await vm.getUser(vm.value)
        if (user) {
          vm.session = user.session ? user.session : ''
          vm.assignadminname = user.adminname
        }
      } catch (error) {
        console.error(error)
      }
      vm.loading = false
      vm.$store.state.livechat.loadingUser = false
    },
    changeAsssign(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          adminname: value
        }
      }
      api.saveuseradminname(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    changeSession(value) {
      var vm = this
      var data = {
        params: {
          pageid: vm.$store.state.livechat.pageid
        },
        body: {
          usersid: this.user.id,
          session: value
        }
      }
      api.saveusersession(data, (error, response) => {
        if (error) {
          // reject(error)
        }
      })
    },
    onResizeChatbox: function() {
      var vm = this
      setTimeout(() => {
        vm.chatboxHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
      }, 500)
    },
    async getUser(value) {
      var data = {
        group_id: value.group_id,
        userid: value.userid,
        pageid: this.$store.state.livechat.pageid
      }
      return await this.$store.dispatch('getLivechatUser', data)
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal == null) {
        // vm.user = undefined
        this.$store.commit('SET_LIVECHAT_USER_DETAIL', null)
      } else if (newVal != oldVal) {
        this.loading = true
        this.$store.state.livechat.loadingUser = true
        this.fetchDataUser()

        // vm.getUser(newVal).then(
        //   function(user) {
        //     if (user) {
        //       vm.user = user
        //     }
        //     vm.loading = false
        //   },
        //   function(error) {
        //     vm.loading = false
        //   }
        // )
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-customers.vue